// export const FirearmType: {
// pistol = 'Pistol',
// revolver = 'Revolver',
// rifle= 'Rifle',
// shotgun = 'Shotgun',
// rifle_shotgun = "Rifle/Shotgun",
// pistol_grip_firearm = "Pistol Grip Firearm",
// frame = "Frame",
// receiver = "Receiver",
// other = "Other",
// silencer = "Silencer",
// machine_gun = "Machine Gun",
// short_barreled_rifle = "Short Barreled Rifle",
// short_barreled_shotgun = "Short Barreled Shotgun",
// destructive_device = "Destructive Device",
// any_other_weapon = "Any Other Weapon",
// antique = "Antique"
// }
export const Answers = {
  yes: 'Yes',
  no: 'No',
};
export const ModalType = {
  modify: 'Modify',
  add: 'Add',
  delete: 'Delete',
  edit: 'Edit',
};
export const ModalID = {
  yes_no: 1,
  status: 2,
  message: 3,
  firearm_management_edit: 4,
  firearm_info_dash: 5,
  edit_bb_firearm: 6,
  edit_bb_acquisition: 7,
  edit_bb_disposition: 8,
  questionnaire_intro: 9,
  digital_signature: 10,
  add_edit_users: 11,
  add_edit_product_service: 12,
  choice: 13,
  add_edit_contact: 14,
  sales_receipt_print: 15,
  firearm_serial_number_list: 16,
  scan_id: 17,
  inventory_options: 18,
  import_vendor_inventory: 19,
  ffl_search: 20,
  user_credentials: 21,
  reserve_inputs: 22,
  drivers_license_selection: 23,
  duplicate_ttsn: 24,
  competitor_pricing: 25,
  dispo_build: 26,
  enter_id: 27,
  kiosk_selection: 28,
  create_form_3310: 29,
  email: 30,
  text_modal: 31,
  ffl_packing_slip_print: 32,
  add_bound_book: 33,
  bound_book_print: 34,
  optimizer_item: 35,
  add_edit_event: 36,
  inventory_alerts: 37,
};
export const State = {
  acquisition: 'Available',
  destroy: 'Destroy',
  disposition: 'Disposed',
  in_progress: 'In Progress',
  lost_stolen: 'Lost Stolen',
  reserved: 'Reserved',
  store_use: 'Store Use',
};
export const Events = {
  create_acquisition: 'Create Acquisition',
  modify_acquisition: 'Modify Acquisition',
  delete_acquisition: 'Delete Acquisition',

  create_disposition: 'Create Disposition',
  modify_disposition: 'Modify Disposition',
  delete_disposition: 'Delete Disposition',

  modify_firearm: 'Modify Firearm',
};
export const StatusModalIndicator = {
  dot: 'dot',
  spinner: 'spinner',
  counter: 'counter',
  percentage: 'percentage',
};
export const FirearmTypes: string[] = [
  'Pistol',
  'Revolver',
  'Rifle',
  'Shotgun',
  'Receiver',
  'Silencer',
  'Rifle/Shotgun',
  'Pistol Grip Firearm',
  'Frame',
  'Other',
  'Machine Gun',
  'Short Barreled Rifle',
  'Short Barreled Shotgun',
  'Destructive Device',
  'Any Other Weapon',
  'Antique',
];
export const NFATypes: string[] = [
  'Silencer',
  'Machine Gun',
  'Short Barreled Rifle',
  'Short Barreled Shotgun',
  'Destructive Device',
  'Any Other Weapon',
];

export const FFLMonthCharacters: string[] = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'J',
  'K',
  'L',
  'M',
];
export const images = {
  rifle: '../../assets/images/rifle-icon.jpg',
  shotgun: '../../assets/images/shotgun-icon.jpg',
};
export * from './reference-data';

export const Questions = {
  correct_ffl: 'Is this the correct FFL?',
  use_this_firearm: 'Would you like to use this firearm data?',
  add_this_firearm: 'Would you like to add this firearm for future use?',
  add_product_item_data: 'Would you like to use this product item data?',
  cancel_4473_form: 'Are you sure you want to cancel the 4473 form?',
  reset_4473_form: 'Are you sure you want to reset the 4473 form?',
  void_sales_receipt: 'Are you sure you want to void receipt',
  adding_inv_or_service: 'Are you adding inventory or a service?',
  submit_disposition: 'Are you sure you want to submit this disposition?',
  form4473_id_already_exists:
    'This 4473 ID already exists.\n Would you like to add to that record?',
  parse_invoice: 'Would you like to parse this invoice to auto-populate the form?',
  revert_disposition: `Are you sure you want to revert this disposition?`,
  reset_optimizer: 'Are you sure you want to reset all optimization results?',
  // Delete
  delete_inv_alert: 'Are you sure you want to delete this inventory alert?',
  delete_vendor: 'Are you sure you want to delete this vendor?',
  delete_auto_purchase: 'Are you sure you want to delete this auto purchase?',
  delete_contact: 'Are you sure you want to delete this contact?',
  delete_customer: 'Are you sure you want to delete this customer?',
  delete_this_firearm: 'Are you sure you want to delete this firearm?',
  delete_this_ffl: 'Are you sure you want to delete this FFL?',
  delete_this_user: 'Are you sure you want to delete this user?',
  delete_product: 'Are you sure you want to delete this product?',
  delete_sales_receipt: 'Are you sure you want to delete receipt',
  delete_service: 'Are you sure you want to delete this service?',
  delete_user: 'Are you sure you want to delete this user?',
  delete_expense_record: 'Are you sure you want to delete this expense record?',
  delete_draft: 'Are you sure you want to delete this pending disposition?',
  delete_event: 'Are you sure you want to delete this event?',
  delete_serial:
    'Are you sure you want this serial entry removed? Your bound book will not align with accounting inventory levels.',
  delete_bulk_serial_item:
    'Are you sure you want this item removed? Your bound book will not align with accounting inventory levels.',
  delete_purchase_optimizer_item:
    'Are you sure you want this item removed?',  
  close_bulk_acquisition:
    'Are you sure you want to close this bulk acquisition? Your bound book will not align with accounting inventory levels.',
  generate_form_3310:
    'This 4473 includes multiple handguns. Would you like to generate and email the Form 3310.4?',
  revert_firearm:
    'Are you sure you want to remove this firearm from the reserve list?',
  revert_firearm_all:
    'Are you sure you want to remove all firearms from the reserve list?',
  remove_4473:
    'Are you sure you want to remove this 4473 from the reserve list?',
  close_create_product_service:
    'Are you sure you want to close this modal? This UPC will cleared from the form.',
  close_add_firearm_modal:
    'Are you sure you want to close this modal? This UPC will cleared from the form.',
};
export const Statements = {
  // acquisition comments
  acquisition_successfully_created: 'Acquisition has been successfully added.',
  acquisition_successfully_modified:
    'Acquisition has been successfully modified.',
  acquisition_successfully_deleted:
    'Your Acquisition has been successfully deleted.', // may not be needed
  // firearm comments
  firearm_successfully_added:
    'Firearm has been successfully added for future use',
  firearm_failed_to_be_added: 'Failed to add firearm',
  firearm_successfully_deleted: 'Firearm has been successfully deleted',
  firearm_failed_to_delete: 'Failed to delete firearm',
  firearm_successfully_updated: 'Firearm has been successfully modified',
  firearm_failed_to_update: 'Failed to update firearm',
  // ffl comments
  ffl_successfully_added: 'FFL has been successfully add for future use',
  ffl_failed_to_be_added: 'Failed to add FFL',
  ffl_successfully_deleted: 'FFL has been successfully deleted',
  ffl_failed_to_delete: 'Failed to delete FFL',
  ffl_successfully_updated: 'FFL has been successfully modified',
  ffl_failed_to_update: 'Failed to update FFL',
  ffl_expired: 'FFL has expired. Please select a valid FFL',
  // user comments
  user_successfully_added: 'User has been successfully added',
  user_failed_to_be_added: 'Failed to add User',
  user_successfully_deleted: 'User has been successfully deleted',
  user_failed_to_delete: 'Failed to delete User',
  user_successfully_updated: 'User has been successfully modified',
  user_failed_to_update: 'Failed to update User',
  // general comments
  no_values_changed: 'No values were changed. Nothing to save.',
  greater_then_zero: 'Value must be greater than zero',
  // vendor comments
  vendor_successfully_deleted: 'Vendor has been successfully deleted',
  vendor_failed_to_delete: 'Failed to delete Vendor',
  vendor_failed_to_edit: 'Failed to edit Vendor',
  vendor_successfully_updated: 'Vendor has been successfully modified',
  // customer comments
  customer_successfully_deleted: 'Customer has been successfully deleted',
  customer_failed_to_delete: 'Failed to delete Customer',
  customer_failed_to_edit: 'Failed to edit Customer',
  customer_successfully_updated: 'Customer has been successfully modified',
  // company info comments
  company_info_successfully_updated:
    'Company information has been successfully modified',
  // contact comments
  updating_contact_table: 'Updating contact table',
  // incorrect file type
  incorrect_file_type_csv_xlsx:
    'Invalid file type. Please select a .csv or .xlsx file.',
  // Product / Service comments
  product_successfully_added: 'Product has been successfully added',
  product_failed_to_add: 'Failed to add product',
  product_failed_to_delete: 'Failed to delete product',
  product_failed_to_update: 'Failed to update product',
  product_successfully_deleted: 'Product has been successfully deleted',
  inventory_successfully_updated: 'Inventory has been successfully updated',
  service_successfully_added: 'Service has been successfully added',
  service_failed_to_add: 'Failed to add service',
  service_failed_to_delete: 'Failed to delete service',
  service_failed_to_update: 'Failed to update service',
  service_successfully_deleted: 'Service has been successfully deleted',
  service_successfully_updated: 'Service has been successfully updated',
  // Sales Receipt comments
  sales_receipt_deleting: 'Deleting Sales Receipt',
  sales_receipt_voiding: 'Voiding Sales Receipt',
  sales_receipt_successfully_added:
    'Sales Receipt has been successfully added',
  sales_receipt_successfully_deleted:
    'Sales Receipt has been successfully deleted',
  sales_receipt_successfully_updated:
    'Sales Receipt has been successfully updated',
  // Expense Record Comments
  expense_record_successfully_added:
    'Expense Record has been successfully added',
  expense_record_failed_to_add: 'Failed to add Expense Record',
  expense_record_failed_to_delete: 'Failed to delete Expense Record',
  expense_record_failed_to_update: 'Failed to update Expense Record',
  expense_record_successfully_deleted:
    'Expense Record has been successfully deleted',
  expense_record_successfully_updated:
    'Expense Record has been successfully updated',
  reserved_4473_removed: '4473 Successfully removed from the reserve list.',
  reserved_4473_removal_failed: 'Failed to remove 4473 from the reserve list.',
  distributor_config_saved: 'Distributor configuration saved successfully.',
};
export const DateFormats = {
  M_D_Y_H_M_AM: 'MM/dd/yyyy hh:mm:ss a',
  M_D_Y_H_M_S: 'MM/dd/yyyy HH:mm:ss',
  M_D_Y: 'MM/dd/yyyy',
};
export const Roles = {
  admin: 'Admin',
  user: 'User',
  developer: 'Developer',
};

// used when using a datepicker button
export const DateMonthPickerConfig = {
  containerClass: 'theme-dark-blue',
  dateInputFormat: 'MM',
  showWeekNumbers: false,
  isAnimated: true,
  adaptivePosition: true,
  outsideClick: true,
};
export const DatePickerConfig = {
  containerClass: 'theme-dark-blue',
  dateInputFormat: 'MM/DD/YYYY',
  showWeekNumbers: false,
  isAnimated: true,
  adaptivePosition: true,
};
export const DateTimePickerConfig = {
  containerClass: 'theme-dark-blue',
  rangeInputFormat: 'MM/DD/YYYY, h:mm:ss a',
  showWeekNumbers: false,
  isAnimated: true,
  adaptivePosition: true,
};
export const ContactTypes = {
  customer: 'Customer',
  vendor: 'Vendor',
};
export const InventoryTypes = {
  firearm: 'Firearm',
  service: 'Service',
  inventory: 'Inventory',
  serial_item: 'Serial Item',
};
export const AccountingTypes = {
  expense: 'Expense',
  income: 'Income',
};
export const AccountingAccounts = {
  // need to remove the hard coding from the accounting service
  income_asset_account: 'income_asset_account',
  income_account: 'income_account',
  expense_account: 'expense_account',
  inventory_asset_account: 'inventory_asset_account',
};
export const ComponentNames = {
  product_services: 'ProductsServicesComponent',
  expense_table: 'ExpenseTableComponent',
  contact_table: 'ContactTableComponent',
  sales_table: 'SalesTableComponent',
  bound_book: 'BoundBookComponent',
  ffl_management: 'FFLManagementComponent',
  firearm_management: 'FirearmManagementComponent',
  bulk_acquisition: 'BulkAcquisitionComponent',
  vendor_dashboard: 'VendorDashboardComponent',
};
export const NicsMiscNoType = [
  `Air Force Serial Number`,
  `Alien Registration Number or USCIS`,
  `Army Serial Number, National Guard Serial Number or Air National Guard Serial Number, regardless of State`,
  `Canadian Social Insurance Number`,
  `Driver's License Number - State Issued Identification Card`,
  'Fingerprint Identification Number',
  `Marine Corps Serial Number`,
  `Mariner's Document or Identification Number`,
  `Navy Serial Number`,
  `Non_Immigrant Admissions Number`,
  `Other Agency Id`,
  `Passport Number`,
  `personal Identification Number (this applies only to state-issues numbers other than Driver's License Number - State Issues Identification Card)`,
  `Port Security Card Number`,
  `Royal Canadian Mounted Police Identification Number`,
  `U.S. Coast Guard Number`,
  `Veterans Administration Claim Number`,
];
export const SirNames = [
  'Jr',
  'Sr',
  'I',
  'II',
  'III',
  'IV',
  'V',
  'VI',
  'VII',
  'VIII',
  'IX',
  'X',
];
export const NicsResponses = [
  { response: 'Proceed', number: 1 },
  { response: 'Denied', number: 2 },
  { response: 'Cancelled', number: 3 },
  { response: 'Delayed', number: 4 },
];
export enum DispositionTypes {
  ffl = 'FFL',
  individual = 'Individual',
  destroyed = 'Destroyed',
  stolen = 'Stolen',
}
export enum CreationTypes {
  manual = 'Manual',
  auto = 'Auto',
}
export const NoteTypes = {
  acquisition_creation: 'Acquisition',
  acquisition_modification: 'Acquisition Modification',
  disposition_creation: 'Disposition',
  disposition_modification: 'Disposition Modification',
};
export const DistributorList = [
  // {name: 'palmetto', value:  `Palmetto State Armory`},
  {name: 'allen_arms_tactical', value:  `Allen Arms Tactical`, api: false, inventory: true, dotClass: 'dot-blue', label: 'Allen Arms'},
  // {name: 'amchar', value:  `AmChar Wholesale Inc.`},
  // {name: 'bangers', value:  `Bangers`},
  // {name: 'camfour', value:  `Camfour Inc.`},
  {
    name: 'cssi',
    value: `Chattanooga Shooting Supplies Inc.`,
    api: true,
    inventory: true,
    dotClass: 'dot-purple',
    label: 'Chattanooga'
  },
  // {name: 'countrywide_sports', value:  `Countrywide Sports`},
  // {name: 'crow', value:  `Crow Shooting Supply`},
  { name: 'davidsons', value: `Davidsons's`, api: true, inventory: true, dotClass: 'dot-black', label: 'Davidsons' },
  //  {name: 'gun_accessory_supply', value: `Gun Accessory Supply`},
  //  {name: 'gsl_technology', value: `GSL Technology`},
  //  {name: 'hicks', value: `Hicks Inc.`},
  // {name: 'iron_valley', value: `Iron Valley`},
  { name: 'lipseys', value: `Lipsey's`, api: true, inventory: true, dotClass: 'dot-yellow', label: 'Lipseys' },
  // {name: 'mge_wholesale', value:  `MGE Wholesale`},
  // {name: 'msr_distributions', value:  `MSR Distribution`},
  // {name: 'orion', value:  `Orion Wholesale`},
  { name: 'rsr_group', value: `RSR Group Inc.`, api: true, inventory: true, dotClass: 'dot-red', label: 'RSR' },
  // {name: 'sports_south', value:  `Sports South LLC`},
  // {name: 'tactical_gear_distributors', value:  `Tactical Gear Distributors`},
  // {name: 'western_recreation_industries', value:  `Western Recreation Industries`},
  // {name: 'williams_shooters_supply', value:  `Williams Shooters Supply`},
  {
    name: 'zanders',
    value: `Zanders Sporting Goods`,
    api: true,
    inventory: true,
    dotClass: 'dot-green',
    label: 'Zanders'
  },
];
export const FormActions = {
  create: 'Create',
  edit: 'Edit',
};
export const IdTypes = [
  { label: 'Drivers License', value: 'drivers_license' },
  { label: 'Concealed Weapons License', value: 'concealed_weapons_license' },
  { label: 'Passport', value: 'passport' },
  { label: 'Military ID', value: 'military_id' },
  { label: 'Green Card', value: 'green_card' },
];
export const features_mapping: {
  group: string;
  name: string;
  visible: boolean;
}[] = [
  { group: 'global', name: 'chatbot', visible: true },
  { group: 'admin', name: 'admin', visible: true },
  { group: 'admin', name: 'account-dashboard', visible: true },
  {
    group: 'admin',
    name: 'account-dashboard-account-management',
    visible: true,
  },
  { group: 'admin', name: 'account-dashboard-user-management', visible: true },
  {
    group: 'admin',
    name: 'account-dashboard-payment-management',
    visible: true,
  },
  {
    group: 'admin',
    name: 'account-dashboard-distributor-management',
    visible: true,
  },
  {
    group: 'admin',
    name: 'account-dashboard-distributor-management',
    visible: true,
  },
  { group: 'admin', name: 'account-dashboard-change-log', visible: false },
  {
    group: 'admin',
    name: 'account-dashboard-autofill-form-3310',
    visible: true,
  },
  {
    group: 'admin',
    name: 'account-dashboard-email-config',
    visible: true,
  },
  { group: 'admin', name: 'firearm-management', visible: true },
  { group: 'admin', name: 'ffl-management', visible: true },
  { group: 'admin', name: 'reporting', visible: false },
  { group: 'admin', name: 'transfer-reporting', visible: true },

  { group: 'accounting', name: 'accounting', visible: true },
  { group: 'accounting', name: 'create-sales-receipt', visible: true },
  { group: 'accounting', name: 'create-expense', visible: true },
  { group: 'accounting', name: 'lists', visible: true },
  { group: 'accounting', name: 'sales-table', visible: true },
  { group: 'accounting', name: 'expense-table', visible: true },
  { group: 'accounting', name: 'product-services', visible: true },
  { group: 'accounting', name: 'contacts', visible: true },
  { group: 'accounting', name: 'reports', visible: true },
  { group: 'accounting', name: 'sales-tax', visible: true },

  { group: 'accounting-reporting', name: 'profit-loss', visible: true },
  { group: 'accounting-reporting', name: 'balance-sheet', visible: true },
  { group: 'accounting-reporting', name: 'cost-of-goods-sold', visible: true },
  { group: 'accounting-reporting', name: 'sales-tax-libility', visible: true },
  { group: 'accounting-reporting', name: 'cash-flow-statment', visible: true },

  { group: 'acquisitions', name: 'acquisitions', visible: true },
  { group: 'acquisitions', name: 'acquisition', visible: true },
  { group: 'acquisitions', name: 'bulk-acquisitions', visible: false },

  { group: 'dispositions', name: 'dispositions', visible: true },
  { group: 'dispositions', name: 'start-new-disposition', visible: true },
  { group: 'dispositions', name: 'build-disposition', visible: false },
  { group: 'dispositions', name: 'pending-dispositions', visible: true },
  { group: 'dispositions', name: '4473', visible: false },
  { group: 'dispositions', name: 'reserved_firearms', visible: true },
  { group: 'dispositions', name: 'reserved_4473', visible: true },

  { group: 'boundbook', name: 'boundbook', visible: true },
  { group: 'calendar', name: 'calendar', visible: true },
  { group: 'vendor-inventory', name: 'vendor-inventory', visible: true },
  { group: 'vendor-inventory', name: 'live-vendor-inventory', visible: true },
  { group: 'vendor-inventory', name: 'inventory-reports', visible: true },

 

  { group: 'kiosk-mode', name: 'kiosk-mode', visible: true },

  { group: 'help', name: 'help', visible: false },
  { group: 'help', name: 'help-doc', visible: true },
  { group: 'help', name: 'tutorial', visible: true },
  { group: 'help', name: 'faqs', visible: true },

  { group: 'test', name: 'test', visible: true },
];

export type SetupTaskId =
  | 'live-inventory'
  | 'costing-method'
  | 'sales-tax'
  | 'form-3310'
  | 'logo'
  | 'ffl'
  | 'sot'
  | 'email-templates';

export const setup_feature_mapping: {
  group: string;
  name: string;
  requiredTaskId: SetupTaskId;
  disabledReason: string;
}[] = [
  {
    group: 'vendor-inventory',
    name: 'vendor-inventory',
    requiredTaskId: 'live-inventory',
    disabledReason:
      'Vendor Inventory is unavailable until at least one distributor account is selected.',
  },
  {
    group: 'vendor-inventory',
    name: 'live-vendor-inventory',
    requiredTaskId: 'live-inventory',
    disabledReason:
      'Live Vendor Data is unavailable until at least one distributor account is selected.',
  },
  {
    group: 'vendor-inventory',
    name: 'inventory-reports',
    requiredTaskId: 'live-inventory',
    disabledReason:
      'Inventory Requests and Purchase Optimizer are unavailable until at least one distributor account is selected.',
  },
  {
    group: 'accounting',
    name: 'create-sales-receipt',
    requiredTaskId: 'costing-method',
    disabledReason:
      'Create Sales Receipt is unavailable until a costing method is set.',
  },
  {
    group: 'accounting',
    name: 'create-sales-receipt',
    requiredTaskId: 'sales-tax',
    disabledReason:
      'Create Sales Receipt is unavailable until sales tax rates are configured.',
  },
  {
    group: 'accounting',
    name: 'create-expense',
    requiredTaskId: 'costing-method',
    disabledReason:
      'Create Expense is unavailable until a costing method is set.',
  },
];

export const signatureType = [
  { name: 'ffl_employee', alias: 'Transferor Certification' },
  { name: 'buyer', alias: 'Buyer Certification' },
  { name: 'buyer_recert', alias: 'Buyer Recertification' },
];
export const EmailType = {
  ffl: 'ffl_request',
  transfer: 'ffl_transfer',
  gb_transfer: 'gunbroker_transfer',
  form_3310: 'form_3310',
};
